'use client';
import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { LayoutDashboard, TrendingUp, ArrowLeftRight, Users, Settings, BarChart2 } from 'lucide-react';
import { useGlobalStore } from '@/store/useGlobalStore';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const NAV_ITEMS = [
  { labelKey: 'navDashboard', icon: LayoutDashboard, href: '/', matchPaths: ['/'] },
  { labelKey: 'navTrade', icon: TrendingUp, href: '/trade-platform', matchPaths: ['/trade-platform'] },
  { labelKey: 'navFunds', icon: ArrowLeftRight, href: '/transactions', matchPaths: ['/transactions'] },
  { labelKey: 'navAccounts', icon: Users, href: '/sub-accounts', matchPaths: ['/sub-accounts'] },
  { labelKey: 'navAnalysis', icon: BarChart2, href: '/analysis', matchPaths: ['/analysis'] },
  { labelKey: 'navSettings', icon: Settings, href: '/settings', matchPaths: ['/settings'] },
];

const HIDDEN_PATHS = ['/trade-platform', '/economic-calendar'];

export default function BottomNav() {
  const pathname = usePathname();
  const { language } = useGlobalStore();
  const { t } = useTranslation();

  if (HIDDEN_PATHS?.includes(pathname)) return null;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 safe-bottom"
      style={{ background: 'rgba(10,10,15,0.95)', backdropFilter: 'blur(20px)', borderTop: '1px solid var(--border)' }}
    >
      <div className="flex items-center justify-around px-1 pt-2 pb-1">
        {NAV_ITEMS?.map((item) => {
          const isActive = item?.matchPaths?.some((p) =>
            p === '/' ? pathname === '/' : pathname?.startsWith(p)
          );
          const IconComp = item?.icon;
          return (
            <Link
              key={`nav-${item?.href}`}
              href={item?.href}
              className="flex flex-col items-center gap-1 px-2 py-1 rounded-xl transition-all duration-200 min-w-[44px]"
            >
              <div className="relative">
                {isActive && (
                  <motion.div
                    layoutId="nav-indicator"
                    className="absolute inset-0 rounded-xl"
                    style={{ background: 'rgba(245,158,11,0.15)' }}
                    transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                  />
                )}
                <div className={`relative z-10 p-1.5 rounded-xl ${isActive ? 'text-primary' : 'text-muted-foreground'}`}>
                  <IconComp size={20} strokeWidth={isActive ? 2.5 : 1.8} />
                </div>
              </div>
              <span
                className={`text-[9px] font-medium tracking-wide transition-colors ${
                  isActive ? 'text-primary' : 'text-muted-foreground'
                }`}
              >
                {t(item?.labelKey)}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}